export const hamburger = () => {
  const hamburgetBtn = document.getElementById("hamburger-btn");
  const body = document.body;

  hamburgetBtn.addEventListener("click", () => {
    body.classList.toggle("is-hamburger-open");
  });
};
